module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-grid"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row small-collapse"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [(_vm.addNewEnabled) ? _c('button', {
    staticClass: "button primary neptune small",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.onAddNewItem
    }
  }, [_c('i', {
    staticClass: "fi-plus"
  }), _vm._v(" " + _vm._s(_vm.additemtext))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "small-4 columns"
  }), _vm._v(" "), _c('div', {
    staticClass: "small-4 columns text-right"
  }, [_c('button', {
    staticClass: "button secondary neptune small",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.onRefresh
    }
  }, [_c('i', {
    staticClass: "fi-refresh"
  }), _vm._v(" " + _vm._s(_vm.refreshtext))])])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(!_vm.items || !_vm.items.length) ? _c('div', {
    staticClass: "emptytext"
  }, [_vm._v(_vm._s(_vm.emptytext))]) : _vm._e(), _vm._v(" "), (_vm.items && _vm.items.length) ? _c('table', {
    staticClass: "hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(column) {
    return _c('th', {
      attrs: {
        "width": column.width,
        "align": column.align
      }
    }, [_vm._v(_vm._s(column.title))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', _vm._l((_vm.columns), function(column) {
      return _c('td', {
        class: column.class,
        attrs: {
          "width": column.width,
          "align": column.align
        }
      }, [(column.name) ? _c('span', {
        staticClass: "content-cell",
        domProps: {
          "innerHTML": _vm._s(item[column.name])
        }
      }) : _vm._e(), _vm._v(" "), (column.actions) ? _c('span', {
        staticClass: "actions"
      }, _vm._l((column.actions), function(action) {
        return _c('span', {
          staticClass: "action"
        }, [_c('button', {
          class: 'button tiny ' + action.class,
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.onItemAction(action, item)
            }
          }
        }, [(action.html) ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(action.html)
          }
        }) : _vm._e(), (action.text) ? _c('span', [_vm._v(_vm._s(action.text))]) : _vm._e()])])
      }), 0) : _vm._e()])
    }), 0)
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35b9ca2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/DataGrid.vue
// module id = 469
// module chunks = 2